"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Card = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _withSpacing = _interopRequireWildcard(require("../withSpacing"));

var _Heading = _interopRequireDefault(require("../Heading"));

var _LoadingIndicator = _interopRequireDefault(require("../LoadingIndicator"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var styles = {
  "screen-small": "(max-width: 539px)",
  "screen-gt-small": "(min-width: 540px)",
  "screen-medium": "(max-width: 959px)",
  "screen-gt-medium": "(min-width: 960px)",
  "screen-large": "(max-width: 1247px)",
  "screen-gt-large": "(min-width: 1248px)",
  "screen-x-large": "(max-width: 1919px)",
  "screen-gt-x-large": "(min-width: 1920px)",
  "card": "tcl__Card-76274da4",
  "withoutPadding": "tcl__Card-875b2787",
  "loadingIndicator": "tcl__Card-162711d2"
};
/**
 * Card component for use in page layouts.
 */

const Card = ({
  className,
  title,
  hasPadding,
  isLoading,
  children,
  ...props
}) => /*#__PURE__*/_react.default.createElement("div", _extends({
  className: (0, _classnames.default)(styles.card, !hasPadding && styles.withoutPadding, className)
}, props), title && /*#__PURE__*/_react.default.createElement(_Heading.default, {
  level: 2,
  size: "small",
  spacing: "0 0 medium 0"
}, title), isLoading && /*#__PURE__*/_react.default.createElement(_LoadingIndicator.default, {
  className: styles.loadingIndicator
}), children);

exports.Card = Card;
Card.displayName = "Card";
Card.propTypes = { ..._withSpacing.propTypes,

  /**
   * The contents of your card.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Any additional css classes.
   */
  className: _propTypes.default.string,

  /**
   * If truthy, will show a loading indicator in the top right of the card.
   */
  isLoading: _propTypes.default.bool,

  /**
   * If truthy, will render without edge padding. This is useful when you want to specify
   * your own padding and opt out of the default padding cards have per screen size.
   */
  hasPadding: _propTypes.default.bool,

  /**
   * If provided will render a title for the card for you and add some spacing from the content.
   */
  title: _propTypes.default.string
};
Card.defaultProps = {
  isLoading: false,
  title: '',
  className: '',
  hasPadding: true
};

var _default = (0, _withSpacing.default)(Card);

exports.default = _default;